import { TALENT_ARR } from '../../data/define';
import NeededIntelligenceCarousel from './NeededIntelligenceCarousel';
import Divider from '../common/Divider';
import { useTranslation } from '../../hook/useTranslation';

function NeedMoreIntelligence({ intelligences, isSuccess, setIsOpenToggleBtn }) {
  const { t } = useTranslation();
  const neededIntelligences = TALENT_ARR.filter(
    (tlt) => !intelligences.some((intel) => intel.intelligence === tlt.id)
  );

  return (
    <div
      className="w-full py-5 flex flex-col justify-start items-center min-h-[200px] text-[#1C1C1C] text-[16px] font-[700] font-['Pretendard'] bg-white"
      style={{
        display: isSuccess ? 'none' : 'flex',
      }}
    >
      <Divider />
      <div className="w-full pt-5">
        <div className="w-full flex items-center justify-between">
          <div className="flex items-center justify-start gap-2 text-left font-[700] text-[20px]">
            {t('report.need_more.title')}
          </div>
          <div className="font-[400] text-[14px] text-[#767676]">
            <span className="font-[600] text-[#767676]">{8 - intelligences?.length}</span>
            <span>{t('report.need_more.total_count')}</span>
          </div>
        </div>
        <div style={{ width: '100vw', marginLeft: '-20px', marginRight: '-20px' }}>
          <div
            className="mt-[16px] flex items-center justify-start overflow-x-auto pb-2 hide-scrollbar"
            style={{
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            <div className="shrink-0 inline-flex items-center justify-start px-2 gap-2 pl-[20px]">
              {neededIntelligences?.length >= 1 &&
                neededIntelligences?.map((intel, index) => {
                  return (
                    <div
                      key={`${intel.id}-${index}`}
                      className="bg-[#F3F3F3] shrink-0 rounded-[15px] px-3 py-1 text-[14px] text-[#767676]"
                    >
                      {t('talent.' + intel.key)}
                    </div>
                  );
                })}
            </div>
            <div className="shrink-0 w-[20px] h-[10px]" />
          </div>
        </div>
      </div>
      <div className="w-full">
        <NeededIntelligenceCarousel
          neededIntelligenceIds={neededIntelligences.map((intel) => intel.id)}
          setIsOpenToggleBtn={setIsOpenToggleBtn}
        />
      </div>
    </div>
  );
}

export default NeedMoreIntelligence;

